import React from 'react';
import "./footer.css"

const Footer = () => {
  return <footer>Made by Gunish Jain</footer>
}

export default Footer